import { useFormik } from "formik"
import React, { use, useEffect, useState } from "react"
import { motion } from 'framer-motion'
import * as Yup from 'yup'
import FieldInput from "../../Components/FieldInput"
import { FaPlus, FaTrash } from "react-icons/fa6"
import Button from "../../Components/Button"
import API from "../../Common/API"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { setAlert } from "../../Store/Theme/actions"

const initialPlanForm = {
    planName: '',
    planRate: 0,
    downloadLimit: 0,
    planBenefits: [{
        benefits: '',
        tamilBenefits: ''
    }],
    planValidity: 0
}
const EditPlan = ({ match }) => {

    const dispatch = useDispatch()
    const history = useHistory()
    const [buttonDisable, setButtonDisable] = useState(false)
    const [planDetails, setPlanDetails] = useState(initialPlanForm)

    useEffect(() => {
        API.get(`/plans/getPlanById/${match.params.id}`).then((planRes) => {
            if (planRes.status === 200) {
                setPlanDetails(planRes.data.data)
            }
        }).catch((err) => {
            dispatch((setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' })))
        })
        // addBenefitsField()
    }, [])

    const planFormSchema = Yup.object().shape({
        planName: Yup.string().required("Plan Name Is Required"),
        planRate: Yup.number().required("Plan Rate Is Required"),
        planValidity: Yup.number().required("Plan Validity Is Required"),
        downloadLimit: Yup.number().required("Download Limit Is Required"),
        planBenefits: Yup.array().of(
            Yup.object().shape({
                benefits: Yup.string().required("Benefits is required"),
                tamilBenefits: Yup.string().required("Tamil Benefits is required")
            })
        ).min(1, "You need atleast one benefits to save")
    })

    const planForms = useFormik({
        initialValues: planDetails,
        validateOnMount: true,
        validationSchema: planFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            setButtonDisable(true)
            API.post('/plans/editPlan', values).then((planRes) => {
                if (planRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'Plan Edited Successfully', active: true, type: 'success' }))
                    planForms.resetForm()
                    history.goBack()
                    setButtonDisable(false)
                }
            }).catch((err) => {
                dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
                setButtonDisable(false)
            })
        }
    })

    const addBenefitsField = () => {
        const benefits = [...planForms.values.planBenefits];
        benefits.push({ benefits: '', tamilBenefits: '' });
        planForms.setFieldValue('planBenefits', benefits);
    };

    const removeBenefitsField = (index) => {
        const benefits = [...planForms.values.planBenefits];
        benefits.splice(index, 1);
        planForms.setFieldValue('planBenefits', benefits);
    }

    const translateFormHandling = async (text, fieldName) => {
        try {
            const res = await API.post('/common/translate', { text: text });
            if (res.status === 200) {
                const translatedText = res.data.data.translatedText;
                // Update the corresponding field in the form
                console.log(fieldName)
                planForms.setFieldValue(fieldName, translatedText); // Correct field assignment
            }
        } catch (error) {
            console.error("Translation API Error:", error);
        }
    };

    return (
        <motion.div className="w-full h-full flex flex-col gap-4 relative">
            <motion.div className="text-xl font-bold text-primeColor">
                Create Plan
            </motion.div>
            <motion.div className="grid grid-cols-1 gap-2 md:grid-cols-2 sm:grid-cols-1">
                <FieldInput label={'Plan Name'} fieldProps={planForms.getFieldProps('planName')} fieldMeta={planForms.getFieldMeta('planName')} fieldHelper={planForms.getFieldHelpers('planName')} edit={true} dataLoaded={true} />
                <FieldInput label={'Plan Rate'} type="number" fieldProps={planForms.getFieldProps('planRate')} fieldMeta={planForms.getFieldMeta('planRate')} fieldHelper={planForms.getFieldHelpers('planRate')} edit={true} dataLoaded={true} />
                <FieldInput label={'Plan Validity'} type="number" fieldProps={planForms.getFieldProps('planValidity')} fieldMeta={planForms.getFieldMeta('planValidity')} fieldHelper={planForms.getFieldHelpers('planValidity')} edit={true} dataLoaded={true} />
                <FieldInput label={'Download Limit'} type="number" fieldProps={planForms.getFieldProps('downloadLimit')} fieldMeta={planForms.getFieldMeta('downloadLimit')} fieldHelper={planForms.getFieldHelpers('downloadLimit')} edit={true} dataLoaded={true} />
            </motion.div>
            <motion.div className="grid grid-cols-1 w-full">
                {
                    planForms.values.planBenefits && planForms.values.planBenefits.map((_, index) => {
                        return (
                            <motion.div className="flex items-center flex-row w-full justify-start">
                                <FieldInput label={`Benefits ${index + 1}`} outerInjectClass={'w-96'} fieldProps={planForms.getFieldProps(`planBenefits[${index}].benefits`)}
                                    fieldHelper={planForms.getFieldHelpers(`planBenefits[${index}].benefits`)}
                                    fieldMeta={planForms.getFieldMeta(`planBenefits[${index}].benefits`)} edit={true} dataLoaded={true} onChange={(e) => translateFormHandling(e, `planBenefits[${index}].tamilBenefits`)} />
                                <FieldInput label={`Tamil Benefits ${index + 1}`} outerInjectClass={'w-96'} fieldProps={planForms.getFieldProps(`planBenefits[${index}].tamilBenefits`)}
                                    fieldHelper={planForms.getFieldHelpers(`planBenefits[${index}].tamilBenefits`)}
                                    fieldMeta={planForms.getFieldMeta(`planBenefits[${index}].tamilBenefits`)} edit={true} dataLoaded={true} />
                                {planForms.values.planBenefits.length > 1 && <FaTrash className="mx-2 cursor-pointer text-[red]" onClick={() => removeBenefitsField(index)} />}
                                {index === planForms.values.planBenefits.length - 1 && <FaPlus className="cursor-pointer mx-2" onClick={() => addBenefitsField()} />}
                            </motion.div>
                        )
                    })
                }
            </motion.div>
            <motion.div className="flex flex-row w-full justify-center items-center">
                <Button type={'primary'} disabled={buttonDisable} onClick={() => !buttonDisable && planForms.submitForm()}>Save</Button>
                <Button type={'danger'} onClick={() => { planForms.resetForm(); history.goBack() }}>Cancel</Button>
            </motion.div>
        </motion.div>
    )
}

export default EditPlan